import { GROUPS } from './config';
import { IResponses, IRequest, IGroupedLinks, ResultTypes } from './index.d';

const getLinkFromRequest = request => {
    const { url } = request.attributes;
    const parts = url.split('link=');
    return parts[1].split('material=')[0];
};

// eslint-disable-next-line import/prefer-default-export
export const formatResponse = (responses: IResponses, requests: IRequest[]): IGroupedLinks => {
    const { data } = responses || {};
    const groupedLinks = {
        [ResultTypes.notParticipate]: [],
        [ResultTypes.affiliate]: [],
        [ResultTypes.notAffiliate]: [],
        [ResultTypes.wrong]: [],
    };

    data.forEach((response, index) => {
        const { body } = response.attributes;
        if (body?.errors && body?.errors[0]?.error === 422046) {
            groupedLinks[ResultTypes.notParticipate].push({
                link: getLinkFromRequest(requests[index]),
            });
            return;
        }
        const link = body.request?.link || getLinkFromRequest(requests[index]) || '';
        const { affiliateType = 0 } = body?.data?.attributes || {};

        const groupByType = GROUPS[affiliateType];

        groupedLinks[groupByType].push({
            ...body?.data?.attributes,
            link,
        });
    });

    return groupedLinks;
};
